import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { filter, sortBy, map, delay, each, concat } from 'lodash';
import { seq } from 'async';
import Fa from 'react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Tooltip, OverlayTrigger, Collapse } from 'react-bootstrap';
import SearchField from '../../../../components/search-field';
import ProgressBar from '../../../../components/progress-bar';
// Import Actions
import {
  fetchAllConversionStages, updateConversionStage,
  updateConversionStagePositions,
} from '../../SetupActions';

// Import Selectors
import { getConversionStages } from '../../SetupReducer';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getViewableDimensions } from '../../../App/AppReducer';
import CRMInstanceName from '../../../../components/crm-instance-name';
import styles from './styles.css';


// a little function to help us with reordering the result

const mutatedReorder = (list, startIndex, endIndex) => {
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};

const mutatedMove = (source, destination, droppableSource, droppableDestination) => {
  const [removed] = source.splice(droppableSource.index, 1);

  destination.splice(droppableDestination.index, 0, removed);
  const result = {};
  result[droppableSource.droppableId] = source;
  result[droppableDestination.droppableId] = destination;
  return result;
};


class ConversionRatesPage extends Component {
  constructor() {
    super();
    this.state = {
      query: null,
      loading: true,
      loaded: false,
      updatingIds: {},
      skippingIds: {},
      dragging: false,
      blinkId: null,
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.toggleSkip = this.toggleSkip.bind(this);
  }

  componentDidMount() {
    this.loadStages();
  }

  onDragEnd(result) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }

    const earlyStages = [];
    const lateStages = [];
    const excludeStages = [];
    each(this.props.stages, (stage) => {
      if (stage.conversion_stage === 'early') {
        earlyStages.push(stage);
      } else if (stage.conversion_stage === 'late') {
        lateStages.push(stage);
      } else {
        excludeStages.push(stage);
      }
    });
    let destinationList = excludeStages;
    if (destination.droppableId === 'early') {
      destinationList = earlyStages;
    } else if (destination.droppableId === 'late') {
      destinationList = lateStages;
    }
    let sourceList = excludeStages;
    if (source.droppableId === 'early') {
      sourceList = earlyStages;
    } else if (source.droppableId === 'late') {
      sourceList = lateStages;
    }
    const draggedStage = sourceList[source.index];

    const isCurrentDestination = source.droppableId === destination.droppableId;
    if (isCurrentDestination) {
      mutatedReorder(
        destinationList,
        source.index,
        destination.index,
      );
    } else {
      mutatedMove(
        sourceList,
        destinationList,
        source,
        destination,
      );
    }

    const items = concat(earlyStages, lateStages, excludeStages);
    const { updatingIds, skippingIds, dragging } = this.state;
    const draggedId = draggedStage.stage_id;
    if (updatingIds[draggedId] || skippingIds[draggedId] || dragging) {
      // updating
      return;
    }
    this.setState({ dragging: true });
    seq(
      (callback) => {
        if (!isCurrentDestination) {
          this.setState({ updatingIds: { ...updatingIds, [draggedId]: true } });
          const params = {
            conversion_stage: destination.droppableId !== 'exclude' ? destination.droppableId : null,
          };
          if (source.droppableId === 'exclude' && draggedStage.skip_conversion) {
            params.skip_conversion = false;
          }
          this.props.dispatch(updateConversionStage(draggedId, params))
            .then(
              () => {
                callback(null, true);
              },
              () => {
                callback(new Error('Cannot update stage'));
              },
            );
        } else {
          callback(null, true);
        }
      },
      (updated, callback) => {
        const ids = map(items, 'stage_id');
        this.props.dispatch(updateConversionStagePositions(ids))
          .then(
            () => {
              callback(null, true);
            },
            () => {
              callback(new Error('Cannot update positions'));
            },
          );
      },
    )((error, results) => {
      this.setState({ updatingIds: { ...updatingIds, [draggedId]: false }, dragging: false });
      this.blink(draggedStage);
    });
  }

  handleSearch(query) {
    this.setState({ query });
  }


  blink(stage) {
    if (stage) {
      this.setState({ blinkId: stage.stage_id });
      delay(() => {
        this.setState({ blinkId: null });
      }, 500);
    } else {
      this.setState({ blinkId: null });
    }
  }

  loadStages() {
    this.setState({
      loading: true, loaded: false,
    });
    const allFieldsPromise = this.props.dispatch(fetchAllConversionStages());
    allFieldsPromise.then(
      () => {
        this.setState({
          loading: false, loaded: true,
        });
      },
      () => {
        this.setState({
          loading: false, loaded: false,
        });
      },
    );
    return allFieldsPromise;
  }
  toggleSkip(stage) {
    const id = stage.stage_id;
    const { updatingIds, skippingIds } = this.state;
    if (!updatingIds[id] && !skippingIds[id]) {
      this.setState({ skippingIds: { ...skippingIds, [id]: true } });
      const params = {
        skip_conversion: !stage.skip_conversion,
      };
      this.props.dispatch(updateConversionStage(id, params))
        .then(
          () => {
            this.blink(stage);
            this.setState({ skippingIds: { ...skippingIds, [id]: false } });
          },
          () => {
            this.setState({ skippingIds: { ...skippingIds, [id]: false } });
          },
        );
    }
  }

  renderTable() {
    const { viewableDimensions, stages } = this.props;
    const {
      query, updatingIds, dragging, blinkId, skippingIds,
    } = this.state;

    if (stages.length === 0) {
      return (
        <div className="alert alert-danger">
          No stages found.
        </div>
      );
    }

    let filteredStages = stages;
    const isSearching = query && query.trim().length;
    if (isSearching) {
      const re = new RegExp(query, 'i');
      filteredStages = filter(filteredStages, (stage) => {
        const label = stage.label || '';
        const description = stage.description || '';
        const forecast = stage.forecast_category_name || '';
        return (label.match(re) || description.match(re) || forecast.match(re));
      });
    }

    const earlyStages = [];
    const lateStages = [];
    const excludeStages = [];
    each(filteredStages, (stage) => {
      if (stage.conversion_stage === 'early') {
        earlyStages.push(stage);
      } else if (stage.conversion_stage === 'late') {
        lateStages.push(stage);
      } else {
        excludeStages.push(stage);
      }
    });
    const groups = [
      { label: 'Early Stages', id: 'early', stages: sortBy(earlyStages, ['conversion_order']) },
      { label: 'Late Stages', id: 'late', stages: sortBy(lateStages, ['conversion_order']) },
      { label: 'Exclude Stages', id: 'exclude', stages: sortBy(excludeStages, ['conversion_order']) },
    ];

    const skipTooltip = (
      <Tooltip id="skip-tooltip">
        <div>Excluded from all conversion rate calculations.</div>
      </Tooltip>
    );
    const orderTooltip = (
      <Tooltip id="order-tooltip">
        <div>Original stage order from <CRMInstanceName />.</div>
      </Tooltip>
    );
    return (
      <div>
        {stages.length > 0 && false &&
          <nav className="navbar navbar-default navbar-controls">
            <form className="navbar-form navbar-left">
              <SearchField collapsible={false} onSearch={this.handleSearch} />
            </form>
          </nav>
        }
        {filteredStages.length > 0 &&
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Fragment>
              <table className={`table table-striped table-condensed ${styles.table}`}>
                <thead>
                  <tr>
                    <th>&nbsp;</th>
                    <th>Stage</th>
                    <th>Forecast Category</th>
                    <th className="text-right" width="150">
                      <OverlayTrigger placement="top" overlay={orderTooltip}>
                        <span>CRM Order <Fa name="info-circle" className="text-active" /></span>
                      </OverlayTrigger>
                    </th>
                    <th className="text-center" width="150">
                      <OverlayTrigger placement="top" overlay={skipTooltip}>
                        <span>Skip Calculation <Fa name="info-circle" className="text-active" /></span>
                      </OverlayTrigger>
                    </th>
                  </tr>
                </thead>
                {groups.map(group => (
                  <Droppable droppableId={group.id} key={group.id}>
                    {(provided, snapshot) => (
                      <tbody
                        ref={provided.innerRef}
                        className={snapshot.isDraggingOver ? styles.DraggingOver : null}
                      >
                        <tr>
                          <td colSpan="5" className={styles.headingRow}>
                            <strong className="text-uppercase">
                              {group.label}
                            </strong>
                            {group.id === 'exclude' &&
                            <em>&nbsp;These stages will be excluded from all calculations and all views in TruSales.</em>
                              }
                          </td>
                        </tr>
                        {group.stages.length === 0 && <tr><td>&nbsp;</td><td colSpan="4"><em className="text-muted">No {group.label} Found</em></td></tr>}
                        {group.stages.length > 0 && group.stages.map((stage, index) => {
                            const tooltip = (
                              <Tooltip id={`${stage.stage_id}_tooltip`}>{stage.description}</Tooltip>
                            );
                            const updating = updatingIds[stage.stage_id];
                            const blinking = blinkId === stage.stage_id;
                            const skipping = skippingIds[stage.stage_id];
                            const isExcluded = stage.conversion_stage !== 'early' && stage.conversion_stage !== 'late';
                            let arrowName = 'arrows-v';
                            if (group.stages.length > 1) {
                              if (index === 0) {
                                arrowName = 'long-arrow-down';
                              } else if (index === group.stages.length - 1) {
                                arrowName = 'long-arrow-up';
                              }
                            }
                            if (dragging) {
                              arrowName = 'spinner';
                            }
                            let skipIcon = stage.skip_conversion ? 'check-square-o' : 'square-o';
                            let skipCls = stage.skip_conversion ? 'text-danger' : 'text-muted';

                            if (skipping) {
                              skipIcon = 'spinner';
                              skipCls = 'text-muted';
                            }
                            let label = (<strong>{stage.label}</strong>);
                            let categoryLabel = stage.forecast_category;
                            let orderLabel = stage.sort_order;
                            if (isExcluded) {
                              label = (<del className="text-muted">{stage.label}</del>);
                              categoryLabel = (<del className="text-muted">{stage.forecast_category}</del>);
                              orderLabel = (<del className="text-muted">{stage.sort_order}</del>);
                            } else if (stage.skip_conversion) {
                              label = (<span className="text-muted">{stage.label}</span>);
                              categoryLabel = (<span className="text-muted">{stage.forecast_category}</span>);
                              orderLabel = (<span className="text-muted">{stage.sort_order}</span>);
                            }
                            return (
                              <Draggable key={stage.stage_id} draggableId={stage.stage_id} index={index}>
                                {(provided, snapshot) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    className={`${snapshot.isDragging ? styles.dragging : null} ${blinking ? 'animated flash' : ''}`}
                                    style={provided.draggableProps.style}
                                  >
                                    <td
                                      width="30"
                                      className="text-center"
                                      {...provided.dragHandleProps}
                                    >
                                      <Fa
                                        name={arrowName}
                                        spin={dragging}
                                      />
                                    </td>
                                    <td>
                                      <span>{label}</span>&nbsp;
                                      {stage.description !== undefined &&
                                          stage.description !== null &&
                                          stage.description.length > 0 &&
                                          <OverlayTrigger placement="right" overlay={tooltip}>
                                            <Fa name="info-circle" className="text-active" />
                                          </OverlayTrigger>
                                        }
                                    </td>
                                    <td width="150">
                                      {categoryLabel}
                                    </td>
                                    <td className="text-right">{orderLabel}</td>
                                    <td
                                      width="150"
                                      className="text-center"
                                      style={{ cursor: skipping ? 'not-allow' : 'pointer' }}
                                      onClick={(e) => {
                                          e.preventDefault();
                                          this.toggleSkip(stage);
                                        }}
                                    >
                                      {!isExcluded &&
                                      <Fa
                                        name={skipIcon}
                                        className={skipCls}
                                        style={{ fontSize: '1.3em' }}
                                        spin={skipping}
                                      />
                                        }
                                    </td>
                                  </tr>
                                  )}
                              </Draggable>
                            );
                          })}
                        {provided.placeholder}
                      </tbody>
                      )}
                  </Droppable>
                  ))}
              </table>
            </Fragment>
          </DragDropContext>
        }
        {filteredStages.length === 0 &&
          <div className="alert alert-warning">
            {isSearching && <div>No records found matching <code>{query}</code>.</div>}
            {!isSearching && <div>No records found.</div>}
          </div>
        }
      </div>
    );
  }


  renderWarning() {
    const { showWarning } = this.props;
    return (
      <Collapse in={showWarning}>
        <div className="alert alert-danger">
          Please notice that you need to have at least one early stage or late stage active.
        </div>
      </Collapse>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    return (
      <div>
        <Helmet title="Conversion Rates Setup | Sales Stages" />
        <div className="container">
          {loading && <ProgressBar />}
          {!loading && loaded &&
            <div>
              {this.renderWarning()}
              {this.renderTable()}
            </div>
          }
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const stages = getConversionStages(state);
  const goodStages = filter(stages, stage => !stage.skip_conversion &&
      (stage.conversion_stage === 'early' || stage.conversion_stage === 'late'));
  return {
    organization: getUserCurrentOrganization(state),
    viewableDimensions: getViewableDimensions(state),
    stages,
    showWarning: goodStages.length === 0 && stages.length > 0,
  };
}

ConversionRatesPage.propTypes = {
  organization: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  showWarning: PropTypes.bool.isRequired,
  location: PropTypes.shape({}).isRequired,
  viewableDimensions: PropTypes.shape({}).isRequired,
  stages: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ConversionRatesPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(ConversionRatesPage);
